import { Injector } from "@angular/core";
import { MfFunctionRef, mfFunctionRefRegisterFunctionRef, MfModelBase, MfModelConfig, MfModelFieldConfig, MfModelFieldDataTypes, MfModelFieldUserPersonsConfig, mfStringGetInitials, mfStringIsEmptyOrWhitespace, mfTypeIsNullOrUndefined } from "@pattonair/material-framework";


export const AUC_USER_MODEL_CONFIG_ID = "user";

export const AUC_USER_PERSONA_CONFIG: MfModelFieldUserPersonsConfig = {
  requiredFields: {
    type: "userPersona",
  },
  mappings: {
    idMap: "id",
    displayNameMap: "displayName",
    emailMap: "mail",
    photoMap: "userPhoto.contentB64",
    jobTitleMap: "jobTitle",
    initialsMap: "initials",
  }
};

export type AucUserModel = MfModelBase & {
  id?: number;
  lastUpdated?: Date;
  objectId?: string;
  userPrincipalName?: string;
  givenName?: string;
  surname?: string;
  mail?: string;
  displayName?: string;
  jobTitle?: string;
  initials?: string;
}

export type AucUserModelFieldsConfig = {
  [key in keyof Required<AucUserModel>]: MfModelFieldConfig
};

export const getInitialsValueFunctionRef: MfFunctionRef<string, AucUserModel> = {
  function: (injector: Injector, model?: AucUserModel) => {
    if (!mfTypeIsNullOrUndefined(model)) {
      if (!mfTypeIsNullOrUndefined(model.displayName) && !mfStringIsEmptyOrWhitespace(model.displayName)) {
        return mfStringGetInitials(model.displayName);
      }
    }
    return "";
  },
  name: "getInitialsValue",
};
const getInitialsValuePointer = mfFunctionRefRegisterFunctionRef(getInitialsValueFunctionRef);

export const AUC_USER_MODEL_FIELDS_CONFIG: AucUserModelFieldsConfig = {
  initials: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
    valueLoadFormatter: {
      calculated: {
        getValueFunctionPointer: getInitialsValuePointer,
      }
    }
  },
  jobTitle: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
  },
  userPrincipalName: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
  },
  givenName: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
  },
  displayName: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
  },
  mail: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
  },
  surname: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
  },
  objectId: {
    dataType: {
      type: MfModelFieldDataTypes.string
    },
  },
  id: {
    isId: true,
    dataType: {
      type: MfModelFieldDataTypes.int
    }
  },
  lastUpdated: {
    dataType: {
      type: MfModelFieldDataTypes.dateTime
    }
  },
};

export const AUC_USER_MODEL_CONFIG: MfModelConfig = {
  key: AUC_USER_MODEL_CONFIG_ID,
  fields: AUC_USER_MODEL_FIELDS_CONFIG,
  userPersona: AUC_USER_PERSONA_CONFIG,
  autoMapping: {
    constName: "AUC_USER_MODEL_CONFIG",
  }
};